module.exports = __webpack_public_path__ + "05acfdb568b3df49ad31355b19495d4a.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./bower_components/Ionicons/fonts/ionicons.woff?v=2.0.0
 ** module id = 76
 ** module chunks = 0
 **/